import { IRoomsCountsByHouse } from '../../types/newbuilding/layouts';

export function getHouseInfo(
  currentHouseId: number | undefined,
  houses: IRoomsCountsByHouse[],
): IRoomsCountsByHouse | undefined {
  /* В случае всех корпусов id не определен - используем 0 */
  return houses.find(house => house.houseId === currentHouseId || (!house.houseId && currentHouseId === 0));
}
